export const TITLE_COLOR_PALETTE = [
  { hex: '#FFD700', label: 'Gold' },
  { hex: '#E6C98A', label: 'Game Light Gold' },
  { hex: '#A97C50', label: 'Game Gold' },
  { hex: '#DAA520', label: 'GoldenRod' },
  { hex: '#BF9B30', label: 'Game Yellow' },
  { hex: '#B8860B', label: 'DarkGoldenRod' },
  { hex: '#9A7047', label: 'Game Bronze' },
  { hex: '#8B7355', label: 'Game Tan' },
  { hex: '#CD853F', label: 'Peru' },
  { hex: '#D2691E', label: 'Chocolate' },
  { hex: '#8B4513', label: 'SaddleBrown' },
  { hex: '#A0522D', label: 'Sienna' },
  { hex: '#5C4033', label: 'Game Dark Tan' },
  { hex: '#4B1E0E', label: 'Game Brown' },
  { hex: '#2A120A', label: 'Game Dark Brown' },
  { hex: '#6B8E23', label: 'OliveDrab' },
  { hex: '#FF4500', label: 'Orange Red' },
  { hex: '#FF6347', label: 'Tomato' },
  { hex: '#FF7F50', label: 'Coral' },
  { hex: '#FF8C00', label: 'Dark Orange' },
  { hex: '#FFA500', label: 'Orange' },
  { hex: '#FFA07A', label: 'Light Salmon' },
  { hex: '#FA8072', label: 'Salmon' },
  { hex: '#FF0000', label: 'Red' },
  { hex: '#4B0082', label: 'Indigo' },
  { hex: '#800080', label: 'Purple' },
  { hex: '#9400D3', label: 'Dark Violet' },
  { hex: '#9932CC', label: 'Dark Orchid' },
  { hex: '#8A2BE2', label: 'Blue Violet' },
  { hex: '#9370DB', label: 'Medium Purple' },
  { hex: '#7B68EE', label: 'Medium Slate Blue' },
  { hex: '#6A5ACD', label: 'Slate Blue' },
  { hex: '#00008B', label: 'Dark Blue' },
  { hex: '#0000CD', label: 'Medium Blue' },
  { hex: '#0000FF', label: 'Blue' },
  { hex: '#191970', label: 'Midnight Blue' },
  { hex: '#4169E1', label: 'Royal Blue' },
  { hex: '#1E90FF', label: 'Dodger Blue' },
  { hex: '#00BFFF', label: 'Deep Sky Blue' },
  { hex: '#87CEEB', label: 'Sky Blue' },
  { hex: '#006400', label: 'Dark Green' },
  { hex: '#228B22', label: 'Forest Green' },
  { hex: '#00FF00', label: 'Green' },
  { hex: '#008B8B', label: 'Dark Cyan' },
  { hex: '#20B2AA', label: 'Light Sea Green' },
  { hex: '#3CB371', label: 'Medium Sea Green' },
  { hex: '#2E8B57', label: 'Sea Green' },
  { hex: '#66CDAA', label: 'Medium Aquamarine' },
  { hex: '#B0E0E6', label: 'Powder Blue' },
  { hex: '#7FFFD4', label: 'Aquamarine' },
  { hex: '#00FFFF', label: 'Cyan' },
  { hex: '#FFC0CB', label: 'Pink' },
  { hex: '#FFB6C1', label: 'Light Pink' },
  { hex: '#FF69B4', label: 'Hot Pink' },
  { hex: '#FF1493', label: 'Deep Pink' },
  { hex: '#C71585', label: 'Medium Violet Red' },
  { hex: '#FFFFFF', label: 'White' },
  { hex: '#DDA0DD', label: 'Plum' },
  { hex: '#EE82EE', label: 'Violet' },
  { hex: '#DB7093', label: 'Pale Violet Red' },
  { hex: '#FFFF00', label: 'Yellow' },
  { hex: '#FF00FF', label: 'Magenta' },
  { hex: '#808080', label: 'Gray' },
  { hex: '#231F20', label: 'Black' },
] as const;

export const TITLE_BASE_PRICE = 1299;
export const TITLE_COLOR_PRICE = 700;
export const TITLE_EDIT_PRICE = 499;
export const TAG_PRICE = 999;
export const ICON_PRICE = 999;
